import * as React from 'react';
type Props = {
  className?: string;
};
export function Breakfast({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Breakfast"
      className={className}
    >
      <path
        d="M2.28024 32.1429H37.9945M32.9945 32.1429C32.9945 25.0421 27.2382 19.2857 20.1374 19.2857C13.0366 19.2857 7.28024 25.0421 7.28024 32.1429H32.9945ZM8.70881 21.4286L2.14282 14.8626L8.70881 21.4286ZM20.1374 16.4286V7.14288V16.4286ZM31.566 21.4286L38.1319 14.8626L31.566 21.4286Z"
        stroke="currentColor"
      />
    </svg>
  );
}
